import {React} from '@api'
import { Utils } from '@tldraw/core'
import * as css from './Kbd.css'

/* -------------------------------------------------- */
/*                  Keyboard Shortcut                 */
/* -------------------------------------------------- */

const commandKey = () => (Utils.isDarwin() ? '⌘' : 'Ctrl')

export function Kbd({
  variant,
  children,
}: {
  variant: 'tooltip' | 'menu'
  children: string
}): JSX.Element | null {
  return (
    <kbd className={css.root} data-variant={variant}>
      {children.split('').map((k, i) => {
        return <span key={i}>{k.replace('#', commandKey())}</span>
      })}
    </kbd>
  )
}




// WEBPACK FOOTER //
// ./src/modules/whiteboard/components/Kbd/Kbd.tsx